module.exports = __webpack_public_path__ + "img/nl.6e0a056a.svg";